import {
    ReservationTimeState,
    Resource,
    ResourceState,
    ResourceStateReasonClassification,
} from '@mews-commander/data-access';

export const MIN_TIMEUNIT_COUNT = 2;
export const MAX_TIMEUNIT_COUNT = 3;

const SKIP_CLEANING_DISABLED_STATES = [ReservationTimeState.ToBeCheckedOut, ReservationTimeState.CheckOutMissed];
const SKIP_ALL_CLEANING_ENABLED_STATES = [
    ReservationTimeState.Future,
    ReservationTimeState.CheckedIn,
    ReservationTimeState.ToBeCheckedIn,
];

export const DEFAULT_FLAGS: HousekeepingOptionFlags = {
    makeSpaceInspected: false,
    skipTodayCleaning: false,
    skipAllCleaning: false,
    enableCleaning: false,
};

export interface HousekeepingConditionFlagsArgs {
    reservationTimeState: ReservationTimeState;
    isSkipCleaningServiceOptionEnabled: boolean;
    timeUnitCount: number;
    isSkipAllCleaningReservationOptionEnabled: boolean;
    resource: Resource | undefined | null;
}

export interface HousekeepingOptionFlags {
    makeSpaceInspected: boolean;
    skipTodayCleaning: boolean;
    skipAllCleaning: boolean;
    enableCleaning: boolean;
}
export const getHousekeepingStatusConditionFlags = ({
    reservationTimeState,
    isSkipCleaningServiceOptionEnabled,
    timeUnitCount,
    isSkipAllCleaningReservationOptionEnabled,
    resource,
}: HousekeepingConditionFlagsArgs) => {
    const flags: HousekeepingOptionFlags = { ...DEFAULT_FLAGS };

    if (resource) {
        if (resource.state !== ResourceState.Inspected) {
            flags.makeSpaceInspected = true;
        }

        if (
            isSkipCleaningServiceOptionEnabled &&
            timeUnitCount >= MIN_TIMEUNIT_COUNT &&
            !SKIP_CLEANING_DISABLED_STATES.includes(reservationTimeState)
        ) {
            const isTodaysCleaningSkipped =
                resource.state === ResourceState.Inspected &&
                resource.stateReasonClassification === ResourceStateReasonClassification.SkipCleaning;

            if (isSkipAllCleaningReservationOptionEnabled || isTodaysCleaningSkipped) {
                flags.enableCleaning = true;
            }

            if (
                !isSkipAllCleaningReservationOptionEnabled &&
                resource.state === ResourceState.Dirty &&
                reservationTimeState === ReservationTimeState.CheckedIn
            ) {
                flags.skipTodayCleaning = true;
            }

            if (
                !isSkipAllCleaningReservationOptionEnabled &&
                SKIP_ALL_CLEANING_ENABLED_STATES.includes(reservationTimeState) &&
                timeUnitCount <= MAX_TIMEUNIT_COUNT
            ) {
                flags.skipAllCleaning = true;
            }
        }
    }
    return flags;
};
